<template>
  <div class="content-wrappper">
    <div class="col-xs-12 p-20">
      <div class="col-xs-12 p-0 flex-center">
        <img
          @click="checkIsFormTouched"
          src="/static/images/icons/chevron_left.svg"
          class="left-arrow cursor-pointer"
          alt="chevronleft-icon"
        />
        <span @click="checkIsFormTouched" class="pl-10 font-24 header cursor-pointer">{{
          alertId ? 'Update Alert' : 'Create New Alert'
        }}</span>
      </div>
      <div class="row">
        <div class="col-xs-12 plr-25 mb-30">
          <ul class="crumb-trail">
            <li
              class="col-xs-6 p-0"
              v-for="(slide, index) in slidesInfo"
              :key="index"
              :class="{
                'is-active-slide': currentSlider === index,
                completed_slide: currentSlider > index
              }"
            >
              <div class="crumb">
                <img
                  v-if="currentSlider > index"
                  src="/static/images/icons/circle_check.svg"
                  class="breadcrumb-img"
                  alt="check-icon"
                />
                <span class="ml-5">{{ slide.title }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-xs-12 pl-20 pr-20 mb-30" v-show="currentSlider === 0">
        <div class="col-xs-12 p-0 font-18 mb-4 font-medium color-light-black">
          Enter the details below to proceed:
        </div>
        <div class="col-xs-12 p-0 color-light-black font-14 mb-30">
          Mandatory fields are marked with “ <span class="danger">*</span> ” symbol
        </div>
        <div class="col-xs-12 p-0">
          <!-- Title here dude -->
          <div class="col-xs-12 p-0 mb-30">
            <label class="font-14 form-group">Title <span class="danger">*</span></label>
            <div class="col-xs-12 p-0">
              <vue-editor
                class="custom-title"
                @text-change="removeStyles()"
                v-model="$v.alertFormDetails.title.$model"
                :editorToolbar="customToolbar"
              ></vue-editor>
            </div>
          </div>
          <!-- Country and date will go here -->
          <div class="col-xs-12 p-0 mb-30">
            <div class="col-xs-12 col-sm-6 pl-0 xs-pr-0">
              <label class="font-14 form-group">Country <span class="danger">*</span></label>
              <div class="col-xs-12 p-0" v-if="regWatchCountriesList">
                <multiselect
                  :showLabels="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  class="multiselect-single-dropdown"
                  :class="!$v.alertFormDetails.countryName.$model ? 'un-selected' : ''"
                  :searchable="true"
                  :options="regWatchCountriesList.map((regCountry) => regCountry.country_name)"
                  v-model="$v.alertFormDetails.countryName.$model"
                  placeholder="Select country"
                >
                  <span slot="noResult">No matching data</span>
                </multiselect>
              </div>
            </div>
            <div class="col-xs-6 col-sm-3 pr-0 xs-pl-0">
              <label class="font-14 form-group">Effective Date</label>
              <div class="col-xs-12 p-0 effective_date_picker">
                <date-picker
                  :editable="false"
                  v-model="$v.alertFormDetails.regulatoryEffectiveDate.$model"
                  valueType="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                  placeholder="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  @change="checkisPreviousDate"
                >
                </date-picker>
              </div>
            </div>
          </div>
          <!-- Description will come here dude -->
          <div class="col-xs-12 p-0 mb-30">
            <label class="font-14 form-group">Description <span class="danger">*</span></label>
            <div class="col-xs-12 p-0 edit-profile-section">
              <vue-html5-editor
                ondrag="return false"
                ondrop="return false"
                autocomplete="off"
                id="Answer"
                :height="145"
                :auto-height="false"
                :content="alertFormDetails.description"
                @change="updateDescription"
              ></vue-html5-editor>
            </div>
          </div>
          <!-- Links will come here dude -->
          <div class="col-xs-12 p-0 mb-20" v-for="(linkItem, index) in linkList" :key="index">
            <div class="col-xs-12 col-sm-6 pl-0 xs-pr-0 xs-mb-15">
              <label class="font-14 form-group">Add link</label>
              <div class="col-xs-12 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="http://"
                  v-model="linkItem['link']"
                  :class="
                    linkItem['invalid'] && !!linkItem['link'].length ? 'error_msg_display' : ''
                  "
                  @input="validateUrl(linkItem)"
                  @paste="onPaste($event, index)"
                />
                <div v-if="linkItem['invalid'] && !!linkItem['link'].length" class="danger">
                  Please enter valid url
                </div>
              </div>
            </div>
            <div class="col-xs-8 col-sm-4 xs-pl-0">
              <label class="font-14 form-group">Link label</label>
              <div class="col-xs-12 p-0">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Link label"
                  v-model="linkItem['label']"
                  :disabled="linkItem.label_disabled"
                />
              </div>
            </div>
            <div class="col-xs-4 col-sm-2 pr-0">
              <!-- <label class="font-14 color-light-black"></label> -->
              <div class="col-xs-12 p-0 mt-25">
                <button
                  id="addLink"
                  data-toggle="tab"
                  class="no-wrap emergo-white-button w-100 add-remove-btn"
                  @click="addOrRemoveLink(index)"
                >
                  {{ linkList.length - 1 > index ? 'Remove' : 'Add'
                  }}<span class="sm-hidden"> Link</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 pl-20 pr-20" v-if="currentSlider === 1">
        <preview-alert-form :alertDetails="alertFormDetails"></preview-alert-form>
      </div>
      <div class="col-xs-12 pl-20 pr-20">
        <div class="col-xs-12 pl-0 pr-0 pt-20 footer-wrapper flex-between">
          <div>
            <button
              class="mb-10 emergo-white-button sm-mr-15 plr-30"
              :class="{ opacity: currentSlider === 0 }"
              :disabled="!currentSlider"
              @click="changeSlider"
            >
              Back
            </button>
            <button
              v-if="
                !alertRecordDetails ||
                (alertRecordDetails && alertRecordDetails.Status !== 'Published')
              "
              class="mb-10 emergo-green-button xs-ml-15"
              :class="{ opacity: isDisabled }"
              :disabled="isDisabled"
              @click="submitDetails(true)"
            >
              Save For Later
            </button>
          </div>
          <div>
            <button class="sm-mr-15 mb-10 emergo-white-button plr-22" @click="checkIsFormTouched">
              Cancel
            </button>
            <button
              class="mb-10 emergo-green-button xs-ml-15 plr-55"
              :class="{ opacity: isDisabled }"
              :disabled="isDisabled"
              @click="submitDetails()"
            >
              {{ currentSlider === 0 ? 'Next' : 'Submit' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <confirm-popup></confirm-popup> -->
    <confirmation-modal
      :confirmationMessage="confirmationMessage"
      @discardChanges="hideConfirmPopup"
    >
    </confirmation-modal>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import $ from 'jquery';
import VueHtml5Editor from 'vue-html5-editor';
import { cloneDeep, isEqual } from 'lodash';
import { VueEditor } from 'vue2-editor';
import { required } from 'vuelidate/lib/validators';
import Vue from 'vue';
import Loader from '../UIComponents/Loader.vue';
import PreviewAlertForm from './PreviewAlertForm.vue';
import ConfirmationModal from '../Common/ConfirmationModal.vue';
import { getRegWatchCountries } from '../../apis/countriesList';
import { saveRegulatoryAlert } from '../../apis/regulatoryUpdate';

Vue.use(VueHtml5Editor, {
  // new VueHtml5Editor(options)
  // global component name
  name: 'vue-html5-editor',
  // if set true,will append module name to toolbar after icon
  showModuleName: false,
  // class，font-awesome
  // custom icon class of built-in modules,default using font-awesome
  icons: {
    text: 'fa fa-pencil',
    color: 'fa fa-paint-brush',
    align: 'fa fa-align-justify',
    list: 'fa fa-list',
    link: 'fa fa-chain',
    unlink: 'fa fa-chain-broken',
    tabulation: 'fa fa-table',
    image: 'fa fa-file-image-o',
    hr: 'fa fa-minus',
    eraser: 'fa fa-eraser',
    undo: 'fa-undo fa',
    'full-screen': 'fa fa-arrows-alt',
    info: 'fa fa-info'
  },

  image: {
    sizeLimit: 512 * 1024,
    upload: {
      url: null,
      headers: {},
      params: {},
      fieldName: {}
    },
    compress: {
      width: 1600,
      height: 1600,
      quality: 80
    },
    //
    uploadHandler(responseText) {
      // default accept json data like  {ok:false,msg:"unexpected"} or {ok:true,data:"image url"}
      const json = JSON.parse(responseText);
      if (!json.ok) {
        return '';
      }
      return json.data;
    }
  },
  language: 'en-us',
  hiddenModules: [],
  visibleModules: [
    'text',
    'color',
    'align',
    'list',
    'link',
    'unlink',
    'tabulation',
    'hr',
    'eraser',
    'undo'
  ],
  modules: {
    // omit,reference to source code of build-in modules
  }
});

export default {
  data() {
    return {
      confirmationMessage: 'Are you sure you want to discard your changes?',
      loaderStatus: false,
      currentSlider: 0,
      alertId: null,
      slidesInfo: [
        {
          title: 'Alert Details'
        },
        {
          title: 'Preview'
        }
      ],
      linkList: [
        {
          link: '',
          label: '',
          label_disabled: true,
          invalid: false
        }
      ],
      regWatchCountriesList: [],
      customToolbar: ['italic'],
      alertFormDetails: {
        title: '',
        countryName: '',
        regulatoryEffectiveDate: '',
        description: ''
      },
      alertFormDetailsCopy: null,
      linksListCopy: null,
      alertRecordDetails: null,
      count: 0
    };
  },

  components: {
    ConfirmationModal,
    DatePicker,
    Loader,
    PreviewAlertForm,
    VueEditor
  },

  computed: {
    isDisabled() {
      if (this.alertId && this.alertRecordDetails && this.alertRecordDetails.Status === 'Draft')
        return false;
      const isLinksAndLablesEntered = this.checkLinksAndLabels();
      if (!this.alertId) {
        return this.$v.alertFormDetails.$invalid || isLinksAndLablesEntered;
      }
      const isLinksChanged = isEqual(this.linkList, this.linksListCopy);
      const isFormChanged = isEqual(this.alertFormDetails, this.alertFormDetailsCopy);
      return (
        this.$v.alertFormDetails.$invalid ||
        isLinksAndLablesEntered ||
        (isFormChanged && isLinksChanged)
      );
    }
  },

  validations: {
    alertFormDetails: {
      regulatoryEffectiveDate: {
        required: false
      },
      title: {
        required
      },
      countryName: {
        required
      },
      description: {
        required
      }
    }
  },

  async created() {
    this.loaderStatus = true;
    this.alertId = this.$route.params.id;
    await this.getRegWatchCountriesList();
    if (this.alertId) {
      this.setAlertFormDetails();
    }
    this.loaderStatus = false;
  },

  methods: {
    async getRegWatchCountriesList() {
      this.regWatchCountriesList = await getRegWatchCountries();
    },

    setAlertFormDetails() {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(+this.alertId)) {
        const alertDetails = JSON.parse(localStorage.getItem(`alertItem${this.alertId}`));
        if (!alertDetails) this.$router.push('/layout/regulatoryUpdatesAdmin');
        this.alertRecordDetails = alertDetails;
        if (alertDetails) {
          const regex = /<\/?(?!(?:em|strong)\b)[a-z](?:[^>"']|"[^"]*"|'[^']*')*>/g;
          const title = `<p>${alertDetails.Title.replace(regex, '')}</p>`;
          this.alertFormDetails = {
            title,
            countryName: alertDetails.Country,
            regulatoryEffectiveDate: moment
              .utc(alertDetails.effectiveDate)
              .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            description: alertDetails.Description
          };
          this.alertFormDetailsCopy = cloneDeep(this.alertFormDetails);
          this.linkList = cloneDeep(alertDetails.linkList);
          this.linksListCopy = cloneDeep(this.linkList);
          this.$v.$reset();
        }
      } else {
        this.$router.push('/layout/regulatoryUpdatesAdmin');
      }
    },

    checkisPreviousDate() {
      if (this.alertFormDetails.regulatoryEffectiveDate) {
        const today = moment().format('YYYY-MM-DD');
        const todayIsoFormat = moment.utc(today).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
        if (+new Date(todayIsoFormat) > +new Date(this.alertFormDetails.regulatoryEffectiveDate)) {
          this.clearNotifications();
          this.$notify({
            type: 'warning',
            title: 'Warning',
            text: 'Past date selection is not allowed',
            group: 'custom-notification'
          });
        }
      }
    },

    changeSlider() {
      this.currentSlider = 0;
    },

    navigateBackToRegWatch() {
      if (this.alertId) {
        localStorage.removeItem(`alertItem${this.alertId}`);
      }
      this.$router.push('/layout/regulatoryUpdatesAdmin');
    },

    checkIsFormTouched() {
      if (this.$v.$anyDirty) {
        $('#confirmPopup').modal({
          backdrop: 'static',
          keyboard: false
        });
      } else {
        this.navigateBackToRegWatch();
      }
    },

    hideConfirmPopup() {
      $('#confirmPopup').modal('hide');
      this.navigateBackToRegWatch();
    },

    addOrRemoveLink(index) {
      if (this.linkList.length - 1 > index) {
        this.linkList.splice(index, 1);
      } else {
        this.linkList.push({
          link: '',
          label: '',
          label_disabled: true,
          invalid: false
        });
      }
    },

    checkLinksAndLabels() {
      for (let i = 0; i < this.linkList.length; i += 1) {
        const isLablesCompletlyEmpty = !this.linkList[i].link && !this.linkList[i].label;
        // eslint-disable-next-line no-continue
        if (isLablesCompletlyEmpty) continue;
        if (this.linkList[i].invalid) return true;
        if (!this.linkList[i].link || !this.linkList[i].label) return true;
      }
      return false;
    },

    updateDescription(description) {
      this.alertFormDetails.description = description;
      this.$v.alertFormDetails.description.$touch();
    },

    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    /* Validate Entered Url */
    validateUrl(itemdetails) {
      const { link } = itemdetails;
      if (link.length === 0) {
        itemdetails.label_disabled = true;
        itemdetails.invalid = false;
      } else {
        const valid = this.isValidUrl(link);
        itemdetails.label_disabled = !valid;
        itemdetails.invalid = !valid;
      }
    },

    isValidUrl(string) {
      try {
        const res = string.match(
          /(http:\/\/|https:\/\/)(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@\-\/]))?/ //eslint-disable-line
        );
        return res !== null;
      } catch (_) {
        return false;
      }
    },

    onPaste(evt, index) {
      if (this.isValidUrl(evt.clipboardData.getData('text'))) {
        this.linkList[index].label_disabled = false;
      } else {
        this.linkList[index].label = '';
      }
    },

    removeStyles() {
      const regex = /<\/?(?!(?:em|strong)\b)[a-z](?:[^>"']|"[^"]*"|'[^']*')*>/g;
      this.alertFormDetails.title = `<p>${this.alertFormDetails.title.replace(regex, '')}</p>`;
      if (this.alertRecordDetails && !this.count) {
        this.$v.$reset();
        this.count += 1;
      }
    },

    submitDetails(isSaveForLater = false) {
      if (isSaveForLater) {
        this.saveAlertDetails(isSaveForLater);
      } else if (this.currentSlider === 0) {
        this.currentSlider += 1;
      } else {
        this.saveAlertDetails(isSaveForLater);
      }
    },

    async saveAlertDetails(isSaveForLater) {
      this.loaderStatus = true;
      this.formatLink();
      this.alertFormDetails.title = this.alertFormDetails.title.replaceAll('<p>', '');
      this.alertFormDetails.title = this.alertFormDetails.title.replaceAll('</p>', '');
      const payload = {
        countryName: this.alertFormDetails.countryName,
        description: this.alertFormDetails.description.replace(/\n/g, '<br/>'),
        infoLink: JSON.stringify(this.linkList),
        isUpdate: !!this.alertId && !isSaveForLater,
        publishedDate: moment().toISOString(),
        title: this.alertFormDetails.title
      };
      if (this.alertFormDetails.regulatoryEffectiveDate)
        payload.regulatoryEffectiveDate = this.alertFormDetails.regulatoryEffectiveDate;
      if ((this.alertId && isSaveForLater) || !this.alertId) {
        payload.isPublishASAP = true;
        payload.isSaveForLater = isSaveForLater;
      }
      if (this.alertId) payload.alertId = +this.alertId;
      const response = await saveRegulatoryAlert(payload);
      this.loaderStatus = false;
      if (response) {
        $('#createAlertModal').modal('toggle');
        this.clearNotifications();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Regulatory alert saved successfully!',
          group: 'custom-notification'
        });
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to save regulatory alert!',
          group: 'custom-notification'
        });
      }
      this.navigateBackToRegWatch();
    },

    formatLink() {
      for (let i = 0; i < this.linkList.length; i += 1) {
        if (
          this.linkList[i].link.toLowerCase().startsWith('http://') ||
          this.linkList[i].link.toLowerCase().startsWith('https://')
        ) {
          return;
        }
        if (this.linkList[i].link) this.linkList[i].link = `http://${this.linkList[i].link}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;
}
.add-remove-btn {
  padding: 6px;
}
.emergo-white-button.plr-22 {
  padding-left: 22px;
  padding-right: 22px;
}
.emergo-white-button.plr-30 {
  padding-left: 30px;
  padding-right: 30px;
}
.emergo-green-button.plr-55 {
  padding-left: 55px;
  padding-right: 55px;
}
//.ml-5 {
//margin-left: 5px;
// }
//.mt-25 {
//margin-top: 25px;
// }
.w-100 {
  width: 100%;
}
.flex-end {
  display: flex;
  align-items: flex-end;
}
.opacity {
  opacity: 0.5;
}
.error_msg_display {
  border-color: red;
}
.effective_date_picker {
  ::v-deep .mx-datepicker {
    width: 144px;
    .mx-input {
      padding: 8px 16px 8px 34px;
      font-size: 14px;
      color: $black;
      border: 1px solid $black;
      border-radius: 3px;
      font-weight: 300;
      height: 36px;
    }
    .mx-input-wrapper {
      .mx-icon-calendar {
        left: 12px;
      }
      .mx-icon-clear {
        right: 116px;
      }
    }
  }
}
.edit-profile-section {
  padding: 0px;
  ::v-deep .vue-html5-editor {
    z-index: 0 !important;
    .toolbar {
      z-index: 0 !important;
    }
  }
}
.danger {
  color: red;
}
.mb-4 {
  margin-bottom: 4px;
}
.w-170 {
  width: 170px;
}
.footer-wrapper {
  border-top: 1px solid $deep-gray;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.font-24 {
  font-size: 24px;
}
.color-light-black {
  color: rgba(0, 0, 0, 0.7);
}
.header {
  font-weight: normal;
  color: #0b3c61;
}
// .mb-30 {
// margin-bottom: 30px;
// }

/* Custom editor title styles */
::v-deep .custom-title {
  .ql-editor {
    min-height: 70px;
    max-height: 70px;
  }
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .ql-snow.ql-toolbar {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 4px 8px 9px;
  }
}
@media (width: 768px) {
  .crumb {
    > .breadcrumb-img {
      vertical-align: middle;
      margin-right: 2px;
      height: 18px;
      width: 18px;
    }
  }
  .crumb-trail {
    > li {
      > .crumb {
        font-size: 15px;
        padding: 16px;
        /* padding: 20px 5px 20px 28px; */
      }
    }
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .crumb-trail {
    > li {
      > .crumb {
        font-size: 16px;
        padding: 16px;
        /* padding: 20px 0px 20px 28px; */
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  .crumb-trail {
    > li {
      &:not(:first-child) {
        > .crumb {
          &:after {
            left: -11px;
          }
          &:before {
            left: -1px;
          }
        }
      }
    }
    > li.is-active-slide {
      > .crumb {
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
      }
    }
  }
}
@media screen and (max-width: 1023px) {
  .sm-hidden {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .completed_slide {
    > .crumb {
      > .breadcrumb-img {
        margin-right: 0px;
        height: 30px;
        width: 30px;
      }
    }
  }
  div.crumb {
    font-size: 18px;
  }
  .crumb-trail {
    > li.completed_slide {
      > .crumb {
        padding: 8px;
      }
    }
    > li {
      &:not(:first-child).completed_slide {
        > .crumb {
          padding: 8px 0px 8px 0px;
          text-align: right;
        }
      }
      > .crumb {
        padding: 12px;
      }
      &:not(:first-child) {
        > .crumb {
          &:after {
            border-top: 23px solid transparent;
            border-bottom: 25px solid transparent;
            border-left: 22px solid #f3f5fb;
          }
          &:before {
            border-top: 22px solid transparent;
            border-bottom: 25px solid transparent;
            border-left: 16px solid $white;
          }
        }
      }
    }
    > li.is-active-slide {
      > .crumb {
        font-size: 16px;
      }
      + {
        li {
          > .crumb {
            &:after {
              border-left-color: $primary;
            }
          }
        }
      }
    }
  }
  .xs-pl-0 {
    padding-left: 0px;
  }
  .xs-pr-0 {
    padding-right: 0px;
  }
  .xs-mb-15 {
    margin-bottom: 15px;
  }
  .xs-ml-15 {
    margin-left: 15px;
  }
}
.crumb-trail {
  margin-top: 20px;
  list-style: none;
  padding: 0px;
  > li.is-active-slide {
    + {
      li {
        > .crumb {
          &:after {
            border-left-color: $primary;
          }
        }
      }
    }
  }
  > li {
    &:first-child {
      > .crumb {
        border-top-left-radius: 40px;
        border-bottom-left-radius: 40px;
      }
    }
    &:last-child {
      > .crumb {
        border-top-right-radius: 40px;
        border-bottom-right-radius: 40px;
      }
    }
    &:not(:first-child) {
      > .crumb {
        margin-left: 10px;
      }
    }
  }
}
// .p-0 {
// padding: 0px;
// }
.crumb {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  color: $deep-gray;
  padding: 16px;
  position: relative;
  cursor: pointer;
  background: #f3f5fa;
  text-align: center;
}
.is-active-slide {
  > .crumb {
    background: $primary;
    color: $deep-white;
  }
}
.pull-left {
  float: left;
}
li {
  &:not(:first-child) {
    > .crumb {
      &:after {
        content: '';
        border-top: 30px solid transparent;
        border-bottom: 25px solid transparent;
        border-left: 28px solid #f3f5fa;
        position: absolute;
        left: -10px;
        top: 0;
        z-index: 1;
      }
      &:before {
        content: '';
        border-top: 30px solid transparent;
        border-bottom: 26px solid transparent;
        border-left: 26px solid $white;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
}
.plr-25 {
  padding-left: 25px;
  padding-right: 25px;
}
@media screen and (min-width: 768px) {
  .sm-mr-15 {
    margin-right: 15px;
  }
}
@media screen and (max-width: 656px) {
  .flex-between {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .xs-pl-0 {
    padding-left: 0px;
  }
  .xs-flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
